import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPlacements } from 'core/actions/ocapi';

import {
  selectGiftGuideConfig,
  selectGiftGuideHeadlineIsLoading,
  selectGiftGuideHeadlineIsLoaded,
  selectGiftGuideHeadlinePlacement,
  selectGiftGuideFeaturedDealsIsLoading,
  selectGiftGuideFeaturedDealsIsLoaded,
  selectGiftGuideFeaturedDealsPlacements,
} from '../selectors';

export const useGetGiftGuide = () => {
  const giftGuideConfig = useSelector(selectGiftGuideConfig);
  const giftGuideHeadlineIsLoading = useSelector(selectGiftGuideHeadlineIsLoading);
  const giftGuideHeadlineIsLoaded = useSelector(selectGiftGuideHeadlineIsLoaded);
  const giftGuideHeadlinePlacement = useSelector(selectGiftGuideHeadlinePlacement);
  const giftGuideFeaturedDealsIsLoading = useSelector(selectGiftGuideFeaturedDealsIsLoading);
  const giftGuideFeaturedDealsIsLoaded = useSelector(selectGiftGuideFeaturedDealsIsLoaded);
  const giftGuideFeaturedDealsPlacements = useSelector(selectGiftGuideFeaturedDealsPlacements);
  const dispatch = useDispatch();
  const { giftGuideHeadline, giftGuideFeaturedDeals } = giftGuideConfig;

  useEffect(() => {
    if (!giftGuideHeadlineIsLoading && !giftGuideHeadlineIsLoaded) {
      const { api: { params, options } } = giftGuideHeadline;
      dispatch(fetchPlacements(params, options));
    }

    if (!giftGuideFeaturedDealsIsLoading && !giftGuideFeaturedDealsIsLoaded) {
      const { api: { params, options } } = giftGuideFeaturedDeals;
      dispatch(fetchPlacements(params, options));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    giftGuideHeadlinePlacement,
    giftGuideFeaturedDealsPlacements,
  };
};
